<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title">
                                <span class="index">
                                    <i class="soap-icon-star circle"></i>
                                </span>
                                {{ titleinfo[getCurrentLocale] }}
                            </h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="servicesonboard_h4_1[getCurrentLocale]"></h4>
                            <p v-html="servicesonboard_p_1[getCurrentLocale]"></p>
                            <p>
                                {{ meal_text2[getCurrentLocale] }}
                                <a
                                    href="https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf"
                                    target="_blank"
                                    style="font-size:15.9996px; color: #D6254D;"
                                >{{ furtherservices_seat_here[getCurrentLocale] }}</a>.
                            </p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->

        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Service and catering',
                    de: 'Service und Verpflegung',
                },
                // >>> --------------------------
                servicesonboard_h4_1: {
                    en: 'Our service on board',
                    de: 'Unser Service an Bord',
                },
                servicesonboard_p_1: {
                    en: 'On your flight we offer you a selection of food, snacks and drinks for sale.<br />Special foods such as vegetarian-meals, gluten-free meals and diabetics-menus can be booked at least 48 hours prior to departure under <a href="/services">Service</a>.',
                    de: 'Auf Ihrem Flug bieten wir Ihnen eine Auswahl an Speisen, Snacks und Getränken gegen Gebühr an.<br />Spezialessen wie z.B. Vegetarisches Essen, Glutenfreies Essen und Diabetiker-Essen können Sie bis spätestens 48 Stunden vor Abflug online unter <a href="/services">Service</a> reservieren.',
                },
                furtherservices_seat_here: {
                    en: 'here',
                    de: 'hier',
                },                
                meal_text2: {
                    en: 'Further information can be found in our on-board bistro and sales journal (PDF document)',
                    de: 'Nähere Informationen finden Sie in unserem Bord-Bistro- und Bordverkauf-Journal (PDF-Dokument)',
                },                
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
a[target='_blank']:after {
    font-family: 'FontAwesome';
    content: ' \f08e';
}

/* >>>  iPAD -------------------------------------------------------------*/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    h1 {
        font-size: 1.6em;
    }
    .booking-information {
        padding: 20px 30px 30px;
        padding-top: 20px;
        padding-right: 15px;
        padding-bottom: 30px;
        padding-left: 15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/infos/serviceonboard/Home.vue